/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_Status_ClassifyingInputs */

const en_doc_status_classifying = /** @type {(inputs: Doc_Status_ClassifyingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classifying…`)
};

const pt_br2_doc_status_classifying = /** @type {(inputs: Doc_Status_ClassifyingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classificando…`)
};

/**
* | output |
* | --- |
* | "Classifying…" |
*
* @param {Doc_Status_ClassifyingInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const doc_status_classifying = /** @type {((inputs?: Doc_Status_ClassifyingInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Status_ClassifyingInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_status_classifying(inputs)
	return pt_br2_doc_status_classifying(inputs)
});